/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import classnames from 'classnames';
import { ILxsHeroHeaderButtonData } from './lxs-hero-header-button.data';
import { buttonType, ILxsHeroHeaderButtonProps } from './lxs-hero-header-button.props.autogenerated';

export interface ILxsHeroHeaderButtonViewProps extends ILxsHeroHeaderButtonProps<ILxsHeroHeaderButtonData> {
    classNames: string;
    href: string | undefined;
    linkText: string | undefined;
    ariaLabel: string | undefined;
    target: string | undefined;
    iconClassName: string | undefined;
}

/**
 *
 * LxsHeroHeaderButton component
 * @extends {React.PureComponent<ILxsHeroHeaderButtonProps<ILxsHeroHeaderButtonData>>}
 */
class LxsHeroHeaderButton extends React.PureComponent<ILxsHeroHeaderButtonProps<ILxsHeroHeaderButtonData>> {
    private readonly getViewProps = (): ILxsHeroHeaderButtonViewProps => {
        const {
            config: { link, buttonType: type, icon }
        } = this.props;

        return {
            ...this.props,
            classNames: classnames('lxs-hero-header-button', type === buttonType.secondary ? 'msc-cta__secondary' : 'msc-cta__primary'),
            href: link?.linkUrl?.destinationUrl,
            linkText: link?.linkText,
            ariaLabel: link?.ariaLabel,
            target: link?.openInNewTab ? '_blank' : undefined,
            iconClassName: icon && classnames('lxs-hero-header-button__icon', `lxs-hero-header-button--icon-${icon}`)
        };
    };

    public render(): JSX.Element | null {
        const { link, visible } = this.props.config;

        if (visible === false || !link?.linkUrl?.destinationUrl) {
            return null;
        }

        return this.props.renderView(this.getViewProps());
    }
}

export default LxsHeroHeaderButton;
